import { ICommandBarItemProps } from '@fluentui/react';

export const useCsafButtonItemProps = (): ICommandBarItemProps => {
  return {
    key: 'csafButton',
    text: 'CSAF',
    iconProps: { iconName: 'Code' },
    href: '/csaf',
    target: '_blank',
    title: `CSAF directory page for MSRC`,
  };
};
